import { StackProps, VStack } from '@chakra-ui/react';
import React from 'react';

import { ContainerWidth } from './index';

interface ContainerProps extends StackProps {
  width?: ContainerWidth;
  children?: React.ReactNode | React.ReactNode[];
}

const WidthKeys: Record<ContainerWidth, StackProps['maxWidth']> = {
  NARROW: 'container.md',
  STANDARD: 'container.lg',
  WIDE: 'container.xl',
  EXTRA_WIDE: 'container.2xl',
  FULL_WIDTH: undefined,
};

const Container: React.FC<ContainerProps> = ({
  children,
  width = 'STANDARD',
  ...rest
}) => {
  return (
    <VStack paddingX={0} margin="0 auto" maxWidth={WidthKeys[width]} {...rest}>
      {children}
    </VStack>
  );
};

export default Container;
